import { CSSUnit } from '@modules/common/types';
import { BANNER_HEIGHT } from '@modules/infoBanner/constants';
import { useIsInfoBannerVisible } from '@modules/infoBanner/hooks';

interface GetIntegrationsPageContentHeightOptions {
  defaultHeight: `${string}${CSSUnit}`;
}

export const useGetIntegrationsPageContentHeight = ({
  defaultHeight,
}: GetIntegrationsPageContentHeightOptions) => {
  const isInfoBannerVisible = useIsInfoBannerVisible();

  if (isInfoBannerVisible) {
    return `calc(${defaultHeight} - ${BANNER_HEIGHT}px)`;
  }

  return defaultHeight;
};
